<template lang="pug">
child
</template>

<script>
export default {
  name: 'NakedLayout'
}
</script>
